// extracted by mini-css-extract-plugin
export default {"landingPageOption":"LandingPageOption_landingPageOption__aCHGF","header":"LandingPageOption_header__NXqaH"};